import { Injectable } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { AppSettings, LoginType, ScreenName, SubSection } from '../enums/app-settings.enum';
import { UtilitiesService } from '../utilities/utilities.service';
import { CartService } from './cart.service';
import { ApplicationInitializationService } from './application-initialization.service';
import { MagentoStorefrontEventsService } from './magento-storefront-events.service';
declare var window : any;
@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  private currency = AppSettings.LOCAL_CURRENTCY;
  constructor(
    private GTMS: GoogleTagManagerService,
    private UTS: UtilitiesService,
    private CS: CartService,
    private APINITS:ApplicationInitializationService,
    private MSFE: MagentoStorefrontEventsService,
  ) { }
  getPlanType(r: any, item: any) {
    let _type;
    if (item?.productType == 'MOBILE_CONTROLLINE')
      return _type = 'New control line' + ' ' + item?.displayName;
    else if (item?.productType == 'MOBILE_POSTPAID' || item?.commerceItemType == 'etsElifeSku')
      return _type = 'Postpaid plans';
    else if (item?.productType == 'MOBILE_PREPAID')
      return _type = 'Prepaid plans';
    else
      return _type = item?.displayName;
  }
  getListItemType(item: any) {
    let type;
    if (item?.productType == 'MOBILE_CONTROLLINE')
      return type = 'New control line' + ' Listing';
    else if (item?.productType == 'MOBILE_POSTPAID')
      return type = 'Postpaid' + ' Listing';
    else if (item?.productType == 'MOBILE_PREPAID')
      return type = 'Prepaid' + ' Listing';
    else
      return type = item?.displayName;
  }
  getItemCatType(item: any) {
    let type;
    if (item?.productType == 'MOBILE_CONTROLLINE')
      return type = item?.commerceItemCategory;
    else if (item?.productType == 'MOBILE_POSTPAID')
      return type = 'Postpaid plans';
    else if (item?.productType == 'MOBILE_VISITOR_PREPAID')
      return type = 'Visitor Line';
    else if (item?.productType == 'MOBILE_PREPAID')
      return type = 'Prepaid plans';
    else if (item?.commerceItemType == 'etsElifeSku')
      return type = 'eLife_plan';
    else if (item?.typeOfProduct)
      return type = item?.typeOfProduct;
    else
      return type = item?.commerceItemCategory;
  }
  getItemCat2Type(r, item: any) {
    let type;
    if (item?.productType == 'MOBILE_CONTROLLINE')
      return type = r.productName;
    else if (item?.productType == 'MOBILE_POSTPAID')
      return type = 'Postpaid:' + r.productName;
    else if (item?.productType == 'MOBILE_PREPAID')
      return type = r.productName;
    else if (item?.commerceItemType == 'etsElifeSku')
      return type = 'eLife:' + r.productName;
    else
      return type = r.productName;
  }
  async begin_checkout(cart: any,eventname) {
    try{
      let items = [];
      let shippings = [];
      sessionStorage.removeItem('dropShippingCart');
      if (cart && cart?.items && cart?.items.length > 0) {
        for (let i = 0; i < cart?.items.length; i++) {
          const r: any = await this.CS.getProductDetails(cart?.items[i]).toPromise().catch((e) => { this.UTS.error(e.error.message); });
          // localStorage.setItem('ProductData',JSON.stringify(r));
          items.push({
            item_id: cart?.items[i].skuId,
            item_name: cart?.items[i].displayName ? cart?.items[i].displayName : this.getPlanType(null, cart?.items[i]) || '',
            currency: 'AED',
            index: i + 1,
            item_brand: cart?.items[i]?.brand ? cart?.items[i]?.brand :"",
            item_category: this.getItemCatType(cart?.items[i]) || '',
            item_extras1: (r && r.productName) ? this.getItemCat2Type(r, cart?.items[i]) : cart?.items[i]?.displayName || '', // Ex: Postpaid: Freedom and New Freedom, eLife: eLife and eLife Lite, Devices: Withing Smarthome: Smart TV or Smart Speakers or Routers or Others.
            item_extras2: '',
            item_list_id: localStorage.getItem('subCategory') || '' , // SKUID of Freedom live plans
            item_list_name: localStorage.getItem('title') || '' ,// Plan name
            price: (cart?.items[i] && cart?.items[i].paymentOptions && cart?.items[i].paymentOptions.price) ? cart?.items[i].paymentOptions.price : (cart?.items[i].price && cart?.items[i].price.oneTime) ? cart?.items[i].price.oneTime : '',
            quantity: cart?.items[i].quantity,
            contract_type: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : '', //if applicable (12 Months Commitment, No Commitment)
            coupon: (cart.coupon) ? cart.coupon : 'Nil', //if applicable
            discount: cart.discount || 'Nil', //if applicable
            sim_type: cart?.items[i]?.commerceItemSubType ? cart?.items[i]?.commerceItemSubType : "",
            esim_device: (cart?.items[i] && cart?.items[i]?.watchEid) ? "Apple Watch." : "Smartphone/Tablets"
            // item_variant: "green" //if applicable
          });
          if (r && r.hasOwnProperty('dropShippingList') && r.dropShippingList.length >= 0 && r?.productId) {
            const dropShipping = {
              isAvailable: r.dropShippingList[0]?.available,
              shippingPartner: r.dropShippingList[0]?.shippingPartner,
              productId: r?.productId
            };
            shippings.push(dropShipping);
          }
          else {
            const dropShipping = {
              isAvailable: false,
              shippingPartner: null,
              productId: null
            };
            shippings.push(dropShipping);
          }
        }
      }
      sessionStorage.setItem('dropShippingCart',JSON.stringify(shippings));
      const language =
        this.UTS.getLocaleLanguage() &&
          this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : '-AR';
      const payload = {
        event: eventname,
        user_env: this.UTS.getENV(),
        value: (cart && cart.totalPayNow) ? cart.totalPayNow : 0,
        currency: 'AED',
        item: items,
      };
      // this.pushDateOnGoogleAnalytics(payload);

    } catch(e){
      this.UTS.log(e);
    }
  }


  // getProductDetail() {
  //   window.location.href = environment.HOST + '/b2c/eshop/viewProducts';
  //   https://qacms-uat.etisalat.ae/b2c/eshop/getPostPaidPlanProduct/prod860022
  //   throw new Error('Method not implemented.');
  // }

  async add_shipping_info(cart: any) {
    try{
      let items = [];
      if (cart && cart?.items && cart?.items.length > 0) {
        for (let i = 0; i < cart?.items.length; i++) {

          const r: any = await this.CS.getProductDetails(cart?.items[i]).toPromise().catch((e) => { this.UTS.error(e.error.message); });

          items.push({
            item_id: cart?.items[i].skuId || '',
            item_name: cart?.items[i]?.displayName || '',
            device_type: this.UTS.getENV(), //App
            currency: 'AED',
            index: i + 1,
            item_brand: cart?.items[i]?.brand ? cart?.items[i]?.brand :"",
            item_category: this.getItemCatType(cart?.items[i]) || '',
            item_category2: (r && r?.productName) ? this.getItemCat2Type(r, cart?.items[i]) : cart?.items[i]?.displayName || '', // Ex: Postpaid: Freedom and New Freedom, eLife: eLife and eLife Lite, Devices: Withing Smarthome: Smart TV or Smart Speakers or Routers or Others.
            item_category3: '',
            item_category4: '',
            item_category5: '',
            item_list_id: cart?.items[i]?.productId || '',// SKUID of Freedom live plans
            item_list_name: cart?.items[i]?.parentDisplayName ? cart?.items[i]?.parentDisplayName : cart?.items[i]?.displayName,// Plan name
            item_variant: (cart?.items[i] && cart?.items[i].variant) ? cart?.items[i].variant : '',
            price: (cart?.items[i] && cart?.items[i].paymentOptions && cart?.items[i].paymentOptions.price) ? cart?.items[i].paymentOptions.price : (cart?.items[i].price.oneTime) ? cart?.items[i].price.oneTime : '',
            quantity: cart?.items[i].quantity,
            contract_type: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : '', //if applicable (12 Months Commitment, No Commitment)
            coupon: (cart.coupon) ? cart.coupon : '', //if applicable
            discount: cart.discount || '', //if applicable
            sim_type: cart?.items[i]?.commerceItemSubType ?cart?.items[i]?.commerceItemSubType : "",
            esim_device: (cart?.items[i] && cart?.items[i]?.watchEid) ? "Apple Watch." : "Smartphone/Tablets"
            // item_variant: "green" //if applicable
          });
        }
      }
      const language =
        this.UTS.getLocaleLanguage() &&
          this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : '-AR';
      const payload = {
        event: 'add_shipping_info_old',
        user_env: this.UTS.getENV(),
        value: cart && cart.totalPayNow || '',
        currency: 'AED',
        item: items,
      };
      this.pushDateOnGoogleAnalytics(payload);

    } catch(e){
      this.UTS.log(e);
    }
  }

  async onCheckout(cart: any, step?, desc?) {
    try{
      let items = [];
      if (cart && cart?.items && cart?.items.length > 0) {
        for (let i = 0; i < cart?.items.length; i++) {
          const r: any = await this.CS.getProductDetails(cart?.items[i]).toPromise().catch((e) => { this.UTS.error(e.error.message); });
          if (cart?.items[i]?.productType) {
            items.push({
              id: cart?.items[i]?.productId || '',
              name: this.getPlanType(null, cart?.items[i]) || '',
              price: (cart?.items[i] && cart?.items[i].paymentOptions && cart?.items[i].paymentOptions.price) ? cart?.items[i].paymentOptions.price : (cart?.items[i].price.oneTime) ? cart?.items[i].price.oneTime : '',
              brand: cart?.items[i]?.brand || '',
              category: this.getItemCatType(cart?.items[i]) || '',
              dimension1: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : (cart?.items[i] && cart?.items[i].paymentOptions) ? cart?.items[i].paymentOptions.type : '', //String - Depends on plan category ( 12 months )
              dimension2: this.getSpecs(cart?.items[i], 'storage') || '', //String - Capacity 2 Bundle (if available)
              dimension3: this.getSpecs(cart?.items[i], 'display') || '', //String - Size (if available)
              dimension4: this.getSpecs(cart?.items[i], 'colour') || '', //String - Color 1 (if available)
              dimension5: '', //String - Color 2 Bundle (if available)
              dimension6: this.getSpecs(cart?.items[i], 'type') || '', //String - Strap Type (if available)
              dimension7: '', //String - Strap Color (if available)
              dimension8: '', //String - Connectivity (if available)
              dimension9: '', //String - Payment Method (if available)
              dimension10: '', //String - Number Selection Option (if available)
              dimension11: '', //String - Number Selected (if available)
              dimension12: (cart?.items[i] && cart?.items[i].paymentOptions) ? cart?.items[i].paymentOptions.type : '', //String - Plan Selected (if available)
              dimension13: (cart?.items[i] && cart?.items[i].addons) ? cart?.items[i] && cart?.items[i].addons[0].displayName : '', //String - Add-On Name 1 (if available)
              dimension14: (cart?.items[i] && cart?.items[i].addons) ? (cart?.items[i] && cart?.items[i].addons[1]) ? cart?.items[i] && cart?.items[i].addons[1].displayName : '' : '', //String - Add-On Name 2 (if available)
              dimension15: '', //String - Add-On Payment Option 1 (if available)
              dimension16: '', //String - Add-On Payment Option 2 (if available)
              dimension17: '', //String - Availability (if available)
              dimension18: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i]?.contractDuration : '', //String - SIM Card option (if available)
              // dimension25: (r && r.productName) ? this.getItemCat2Type(r, cart?.items[i]) : cart?.items[i]?.displayName || '', //String - Category  (if available) Ana Emirati or Emirati Wasel
              dimension25: r?.productName || '',
              quantity: cart?.items[i]?.quantity,
              sim_type: cart?.items[i].commerceItemSubType ? cart?.items[i].commerceItemSubType : "",
              esim_device: (cart?.items[i] && cart?.items[i]?.watchEid) ? "Apple Watch." : "Smartphone/Tablets"
            });
          } else { //for device
            items.push({
              id: cart?.items[i]?.productId || '',
              name: this.getPlanType(null, cart?.items[i]) || '',
              price: (cart?.items[i] && cart?.items[i].paymentOptions && cart?.items[i].paymentOptions.price) ? cart?.items[i].paymentOptions.price : (cart?.items[i].price.oneTime) ? cart?.items[i].price.oneTime : '',
              brand: cart?.items[i]?.brand || '',
              category: this.getItemCatType(cart?.items[i]) || '',
              dimension1: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : (cart?.items[i] && cart?.items[i].paymentOptions) ? cart?.items[i].paymentOptions.type : '', //String - Depends on plan category ( 12 months )
              dimension2: this.getSpecs(cart?.items[i], 'storage') || '', //String - Capacity 2 Bundle (if available)
              dimension3: this.getSpecs(cart?.items[i], 'display') || '', //String - Size (if available)
              dimension4: this.getSpecs(cart?.items[i], 'colour') || '', //String - Color 1 (if available)
              dimension5: '', //String - Color 2 Bundle (if available)
              dimension6: this.getSpecs(cart?.items[i], 'type') || '', //String - Strap Type (if available)
              dimension7: '', //String - Strap Color (if available)
              dimension8: '', //String - Connectivity (if available)
              dimension9: '', //String - Payment Method (if available)
              dimension10: '', //String - Number Selection Option (if available)
              dimension11: '', //String - Number Selected (if available)
              dimension12: (cart?.items[i] && cart?.items[i].paymentOptions) ? cart?.items[i].paymentOptions.type : '', //String - Plan Selected (if available)
              dimension13: '', //String - Add-On Name 1 (if available)
              dimension14: '', //String - Add-On Name 2 (if available)
              dimension15: '', //String - Add-On Payment Option 1 (if available)
              dimension16: '', //String - Add-On Payment Option 2 (if available)
              dimension17: '', //String - Availability (if available)
              dimension18: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i]?.contractDuration : '', //String - SIM Card option (if available)
              // dimension25: (r && r.productName) ? this.getItemCat2Type(r, cart?.items[i]) : cart?.items[i]?.displayName || '', //String - Category  (if available) Ana Emirati or Emirati Wasel
              dimension25: r?.productName || '',
              quantity: cart?.items[i]?.quantity,
              sim_type: cart?.items[i].commerceItemSubType ? cart?.items[i].commerceItemSubType :"",
              esim_device: (cart?.items[i] && cart?.items[i]?.watchEid) ? "Apple Watch." : "Smartphone/Tablets"
            });
          }
        }

        const language =
          this.UTS.getLocaleLanguage() &&
            this.UTS.getLocaleLanguage().toLowerCase() == 'en'
            ? ''
            : '-AR';
        const CheckoutFields = {
          actionField: { 'step': step ? step : 0, action:'checkout' ,option: desc ? desc : ''},  //option : Store Pickup or Get it Delivered depends on selected option
          products: items
        }
        const checkout = {
          checkout: CheckoutFields
        }

        const payload = {
          event: 'checkout',
          user_env: this.UTS.getENV(),
          revenue: cart && cart.totalPayNow || '',
          currencyCode: 'AED',
          ecommerce: checkout,
          eventCallback: function () {
            // document.location = 'checkout.html';
          }
        };
        this.pushDateOnGoogleAnalytics(payload);
      }

    } catch(e){
      this.UTS.log(e);
    }
  }

  async onCheckout2(cart: any, step?, desc?,orderId?) {
    try{
      let items = [];
      if (cart && cart?.items && cart?.items.length > 0) {
        for (let i = 0; i < cart?.items.length; i++) {
          const r: any = await this.CS.getProductDetails(cart?.items[i]).toPromise().catch((e) => { this.UTS.error(e.error.message); });
          if (cart?.items[i].productType) {
            items.push({
              id: cart?.items[i].productId || '',
              name: this.getPlanType(null, cart?.items[i]) || '',
              price: (cart?.items[i] && cart?.items[i].paymentOptions && cart?.items[i].paymentOptions.price) ? cart?.items[i].paymentOptions.price : (cart?.items[i].price.oneTime) ? cart?.items[i].price.oneTime : '',
              brand: cart?.items[i].brand || '',
              category: this.getItemCatType(cart?.items[i]) || '',
              index: i + 1,
              dimension1: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : (cart?.items[i] && cart?.items[i].paymentOptions) ? cart?.items[i].paymentOptions.type : '', //String - Depends on plan category ( 12 months )
              dimension2: this.getSpecs(cart?.items[i], 'storage') || '', //String - Capacity 2 Bundle (if available)
              dimension3: this.getSpecs(cart?.items[i], 'display') || '', //String - Size (if available)
              dimension4: this.getSpecs(cart?.items[i], 'colour') || '', //String - Color 1 (if available)
              dimension5: '', //String - Color 2 Bundle (if available)
              dimension6: this.getSpecs(cart?.items[i], 'type') || '', //String - Strap Type (if available)
              dimension7: '', //String - Strap Color (if available)
              dimension8: '', //String - Connectivity (if available)
              dimension9: '', //String - Payment Method (if available)
              dimension10: '', //String - Number Selection Option (if available)
              dimension11: '', //String - Number Selected (if available)
              dimension12: (cart?.items[i] && cart?.items[i].paymentOptions) ? cart?.items[i].paymentOptions.type : '', //String - Plan Selected (if available)
              dimension13: (cart?.items[i] && cart?.items[i].addons) ? cart?.items[i] && cart?.items[i].addons[0].displayName : '', //String - Add-On Name 1 (if available)
              dimension14: (cart?.items[i] && cart?.items[i].addons) ? (cart?.items[i] && cart?.items[i].addons[1]) ? cart?.items[i] && cart?.items[i].addons[1].displayName : '' : '', //String - Add-On Name 2 (if available)
              dimension15: '', //String - Add-On Payment Option 1 (if available)
              dimension16: '', //String - Add-On Payment Option 2 (if available)
              dimension17: '', //String - Availability (if available)
              dimension18: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : '', //String - SIM Card option (if available)
              dimension25: (r && r.productName) ? this.getItemCat2Type(r, cart?.items[i]) : cart?.items[i]?.displayName || '', //String - Category  (if available) Ana Emirati or Emirati Wasel
              quantity: cart?.items[i].quantity,
            });
          } else { //for device
            items.push({
              id: cart?.items[i].productId || '',
              name: this.getPlanType(null, cart?.items[i]) || '',
              price: (cart?.items[i] && cart?.items[i].paymentOptions && cart?.items[i].paymentOptions.price) ? cart?.items[i].paymentOptions.price : (cart?.items[i].price.oneTime) ? cart?.items[i].price.oneTime : '',
              brand: cart?.items[i].brand || '',
              category: this.getItemCatType(cart?.items[i]) || '',
              index: i + 1,
              dimension1: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : (cart?.items[i] && cart?.items[i].paymentOptions) ? cart?.items[i].paymentOptions.type : '', //String - Depends on plan category ( 12 months )
              dimension2: this.getSpecs(cart?.items[i], 'storage') || '', //String - Capacity 2 Bundle (if available)
              dimension3: this.getSpecs(cart?.items[i], 'display') || '', //String - Size (if available)
              dimension4: this.getSpecs(cart?.items[i], 'colour') || '', //String - Color 1 (if available)
              dimension5: '', //String - Color 2 Bundle (if available)
              dimension6: this.getSpecs(cart?.items[i], 'type') || '', //String - Strap Type (if available)
              dimension7: '', //String - Strap Color (if available)
              dimension8: '', //String - Connectivity (if available)
              dimension9: '', //String - Payment Method (if available)
              dimension10: '', //String - Number Selection Option (if available)
              dimension11: '', //String - Number Selected (if available)
              dimension12: (cart?.items[i] && cart?.items[i].paymentOptions) ? cart?.items[i].paymentOptions.type : '', //String - Plan Selected (if available)
              dimension13: '', //String - Add-On Name 1 (if available)
              dimension14: '', //String - Add-On Name 2 (if available)
              dimension15: '', //String - Add-On Payment Option 1 (if available)
              dimension16: '', //String - Add-On Payment Option 2 (if available)
              dimension17: '', //String - Availability (if available)
              dimension18: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : '', //String - SIM Card option (if available)
              dimension25: (r && r.productName) ? this.getItemCat2Type(r, cart?.items[i]) : cart?.items[i]?.displayName || '', //String - Category  (if available) Ana Emirati or Emirati Wasel
              quantity: cart?.items[i].quantity,
              position: 1, //Number - Position in the list
              Color: this.getSpecs(cart?.items[i], 'colour') || '',
              Storage: this.getSpecs(cart?.items[i], 'storage') || '', // Tablets and Laptops and Smartphones
              Display: this.getSpecs(cart?.items[i], 'display') || '', // Smart TVS
              Contract_type: (cart?.items[i] && cart?.items[i].paymentOptions) ? cart?.items[i].paymentOptions.type : '',//'One time, 12 month, 18 month, 24 month, etc.'

            });
          }
        }

        const language =
          this.UTS.getLocaleLanguage() &&
            this.UTS.getLocaleLanguage().toLowerCase() == 'en'
            ? ''
            : '-AR';
        const CheckoutFields = {
          actionField: { 'step': step ? step : '', 'option': desc ? desc : '' },  //option : Store Pickup or Get it Delivered depends on selected option
          products: items
        }
        const checkout = {
          checkout: CheckoutFields
        }

        const payload = {
          event: 'purchase',
          user_env: this.UTS.getENV(),
          revenue: cart && cart.totalPayNow || '',
          currencyCode: 'AED',
          ecommerce: checkout,
          id:orderId,
          eventCallback: function () {
            // document.location = 'checkout.html';
          }
        };
        this.pushDateOnGoogleAnalytics(payload);
      }

    } catch(e){
      this.UTS.log(e);
    }
  }
  async onPurchase(cart: any, step?:any, desc?:any,orderId?: any) {
    try{
      if (cart && cart?.items && cart?.items.length > 0) {
        let items = [];
        var UUIDTId = ((new Date).getTime().toString(16) + Math.floor(1E7 * Math.random()).toString(16));
        let coupon = "";
        for (let i = 0; i < cart.appliedPromotions.length; i++) {
          coupon = coupon + cart.appliedPromotions[i].name + ",";
        }
        coupon = coupon.substring(0, coupon.length - 1);

        for (let i = 0; i < cart?.items.length; i++) {
          const r: any = await this.CS.getProductDetails(cart?.items[i]).toPromise().catch((e) => { this.UTS.error(e.error.message); });
          if (cart?.items[i].productType) {
            items.push({
              id: cart?.items[i].skuId || '',
              name: this.getPlanType(null, cart?.items[i]) || '',
              price: (cart?.items[i] && cart?.items[i].paymentOptions && cart?.items[i].paymentOptions.price) ? cart?.items[i].paymentOptions.price : (cart?.items[i].price.oneTime) ? cart?.items[i].price.oneTime : '',
              brand: cart?.items[i].brand || '',
              category: this.getItemCatType(cart?.items[i]) || '',
              index: i + 1,
              dimension1: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : (cart?.items[i] && cart?.items[i].paymentOptions) ? cart?.items[i].paymentOptions.type : '', //String - Depends on plan category ( 12 months )
              dimension2: this.getSpecs(cart?.items[i], 'storage') || "", //String - Capacity 2 Bundle (if available)
              dimension3: this.getSpecs(cart?.items[i], 'display') || "", //String - Size (if available)
              dimension4: this.getSpecs(cart?.items[i], 'colour') || "", //String - Color 1 (if available)
              dimension5: '', //String - Color 2 Bundle (if available)
              dimension6: this.getSpecs(cart?.items[i], 'type') || "", //String - Strap Type (if available)
              dimension7: '', //String - Strap Color (if available)
              dimension8: '', //String - Connectivity (if available)
              dimension9: '', //String - Payment Method (if available)
              dimension10: '', //String - Number Selection Option (if available)
              dimension11: '', //String - Number Selected (if available)
              dimension12: (cart?.items[i] && cart?.items[i].paymentOptions) ? cart?.items[i].paymentOptions.type : '', //String - Plan Selected (if available)
              dimension13: '', //String - Add-On Name 1 (if available)
              dimension14: '', //String - Add-On Name 2 (if available)
              dimension15: '', //String - Add-On Payment Option 1 (if available)
              dimension16: '', //String - Add-On Payment Option 2 (if available)
              dimension17: '', //String - Availability (if available)
              dimension18: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : '', //String - SIM Card option (if available)
              dimension25: (r && r.productName) ? this.getItemCat2Type(r, cart?.items[i]) : cart?.items[i]?.displayName || '', //String - Category  (if available) Ana Emirati or Emirati Wasel
              quantity: cart?.items[i].quantity || "",
              coupon: '' // Optional fields may be omitted or set to empty
            });
          } else {
            items.push({
              id: cart?.items[i].skuId || '',
              name: this.getPlanType(null, cart?.items[i]) || "",
              price: (cart?.items[i] && cart?.items[i].paymentOptions && cart?.items[i].paymentOptions.price) ? cart?.items[i].paymentOptions.price : (cart?.items[i].price.oneTime) ? cart?.items[i].price.oneTime : '',
              brand: cart?.items[i].brand || "",
              category: this.getItemCatType(cart?.items[i]) || "",
              index: i + 1,
              dimension1: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : (cart?.items[i] && cart?.items[i].paymentOptions) ? cart?.items[i].paymentOptions.type : '', //String - Depends on plan category ( 12 months )
              dimension2: this.getSpecs(cart?.items[i], 'storage') || "", //String - Capacity 2 Bundle (if available)
              dimension3: this.getSpecs(cart?.items[i], 'display') || "", //String - Size (if available)
              dimension4: this.getSpecs(cart?.items[i], 'colour') || "", //String - Color 1 (if available)
              dimension5: '', //String - Color 2 Bundle (if available)
              dimension6: this.getSpecs(cart?.items[i], 'type') || "", //String - Strap Type (if available)
              dimension7: '', //String - Strap Color (if available)
              dimension8: '', //String - Connectivity (if available)
              dimension9: '', //String - Payment Method (if available)
              dimension10: '', //String - Number Selection Option (if available)
              dimension11: '', //String - Number Selected (if available)
              dimension12: (cart?.items[i] && cart?.items[i].paymentOptions) ? cart?.items[i].paymentOptions.type : '', //String - Plan Selected (if available)
              dimension13: '', //String - Add-On Name 1 (if available)
              dimension14: '', //String - Add-On Name 2 (if available)
              dimension15: '', //String - Add-On Payment Option 1 (if available)
              dimension16: '', //String - Add-On Payment Option 2 (if available)
              dimension17: '', //String - Availability (if available)
              dimension18: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : '', //String - SIM Card option (if available)
              dimension25: (r && r.productName) ? this.getItemCat2Type(r, cart?.items[i]) : cart?.items[i]?.displayName || '', //String - Category  (if available) Ana Emirati or Emirati Wasel
              quantity: cart?.items[i].quantity || "",
              coupon: '',// Optional fields may be omitted or set to empty,
              position: 1, //Number - Position in the list
              Color: this.getSpecs(cart?.items[i], 'colour') || "",
              Storage: this.getSpecs(cart?.items[i], 'storage') || "", // Tablets and Laptops and Smartphones
              Display: this.getSpecs(cart?.items[i], 'display') || "", // Smart TVS
              Contract_type: (cart?.items[i] && cart?.items[i].paymentOptions) ? cart?.items[i].paymentOptions.type : '',//'One time, 12 month, 18 month, 24 month, etc.'

            });
          }
        }

        const language =
          this.UTS.getLocaleLanguage() &&
            this.UTS.getLocaleLanguage().toLowerCase() == 'en'
            ? ''
            : '-AR';
        const CheckoutFields = {
          actionField: {
            id: orderId, // Transaction ID. Required for purchases and refunds.
            affiliation: 'Online Store',
            revenue: cart && cart.totalPayNow || '', // Total transaction value (incl. tax and shipping)
            tax: '0',
            shipping: '0',
            coupon: coupon,
            user_env: this.UTS.getENV(),
          },//pass user device environment
          products: items
        }
        const checkout = {
          purchase: CheckoutFields
        }

        const payload = {
          event: 'purchase',
          user_env: this.UTS.getENV(),
          ecommerce: checkout,
        };
        setTimeout(() => {
          this.pushDateOnGoogleAnalytics(payload);
        }, 500);
      }

    } catch(e){
      this.UTS.log(e);
    }
  }
  getSpecs(cart: any, specType: any) {

    if (cart && cart?.specifications && cart?.specifications.length > 0) {
      let data = cart.specifications;
      for (let i = 0; i < data.length; i++) {
        if (data[i].type.toLowerCase() == specType) {
          return data[i].name;
        }
      }
      return '';
    }
  }

  async add_delivery_preference(cart: any) {
    try{
      let items = [];
      if (cart && cart?.items && cart?.items.length > 0) {
        for (let i = 0; i < cart?.items.length; i++) {
          const r: any = await this.CS.getProductDetails(cart?.items[i]).toPromise().catch((e) => { this.UTS.error(e.error.message); });
          items.push({
            item_id: cart?.items[i]?.skuId || '',
            item_name: cart?.items[i]?.displayName || '',
            currency: 'AED',
            index: i + 1,
            item_brand: cart?.items[i]?.brand ? cart?.items[i]?.brand :"",
            item_category: this.getItemCatType(cart?.items[i]) || '',
            item_category2: (r && r.productName) ? this.getItemCat2Type(r, cart?.items[i]) : cart?.items[i]?.displayName || '', // Ex: Postpaid: Freedom and New Freedom, eLife: eLife and eLife Lite, Devices: Withing Smarthome: Smart TV or Smart Speakers or Routers or Others.
            item_category3: '',
            item_category4: '',
            item_category5: '',
            item_list_id: cart?.items[i]?.productId || '',// SKUID of Freedom live plans
            item_list_name: cart?.items[i]?.parentDisplayName ? cart?.items[i]?.parentDisplayName : cart?.items[i]?.displayName,// Plan name
            item_variant: (cart?.items[i] && cart?.items[i].variant) ? cart?.items[i].variant : '',
            price: (cart?.items[i] && cart?.items[i].paymentOptions && cart?.items[i].paymentOptions.price) ? cart?.items[i].paymentOptions.price : (cart?.items[i].price.oneTime) ? cart?.items[i].price.oneTime : '',
            quantity: cart?.items[i].quantity || '',
            contract_type: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : '', //if applicable (12 Months Commitment, No Commitment)
            coupon: (cart.coupon) ? cart.coupon : '', //if applicable
            discount: cart.discount || '', //if applicable
            // item_variant: "green" //if applicable
          });
        }
      }
      const language =
        this.UTS.getLocaleLanguage() &&
          this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : '-AR';
      const payload = {
        event: 'add_delivery_preference',
        user_env: this.UTS.getENV(),
        value: (cart && cart.totalPayNow) ? cart.totalPayNow : 0,
        currency: 'AED',
        item: items,
      };
      this.pushDateOnGoogleAnalytics(payload);
    } catch(e){
      this.UTS.log(e);
    }
  }
  async confirmLocation_addNewAddress_checkout(cart: any) {
    try{
      let items = [];
      if (cart && cart?.items && cart?.items.length > 0) {
        for (let i = 0; i < cart?.items.length; i++) {
          const r: any = await this.CS.getProductDetails(cart?.items[i]).toPromise().catch((e) => { this.UTS.error(e.error.message); });
          items.push({
            item_id: cart?.items[i].skuId || '',
            item_name: cart?.items[i]?.displayName || '',
            currency: 'AED',
            index: i + 1,
            item_brand: cart?.items[i]?.brand ? cart?.items[i]?.brand :"",
            item_category: this.getItemCatType(cart?.items[i]) || '',
            item_category2: (r && r.productName) ? this.getItemCat2Type(r, cart?.items[i]) : cart?.items[i]?.displayName || '',  // Ex: Postpaid: Freedom and New Freedom, eLife: eLife and eLife Lite, Devices: Withing Smarthome: Smart TV or Smart Speakers or Routers or Others.
            item_category3: '',
            item_category4: '',
            item_category5: '',
            item_list_id: cart?.items[i]?.productId || '',// SKUID of Freedom live plans
            item_list_name: cart?.items[i]?.parentDisplayName ? cart?.items[i]?.parentDisplayName : cart?.items[i]?.displayName,// Plan name
            item_variant: (cart?.items[i] && cart?.items[i].variant) ? cart?.items[i].variant : '',
            price: (cart?.items[i] && cart?.items[i].paymentOptions && cart?.items[i].paymentOptions.price) ? cart?.items[i].paymentOptions.price : (cart?.items[i].price.oneTime) ? cart?.items[i].price.oneTime : '',
            quantity: cart?.items[i].quantity || '',
            contract_type: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : '', //if applicable (12 Months Commitment, No Commitment)
            coupon: (cart.coupon) ? cart.coupon : '', //if applicable
            discount: cart.discount || '', //if applicable
            // item_variant: "green" //if applicable
          });
        }
      }
      const language =
        this.UTS.getLocaleLanguage() &&
          this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : '-AR';
      const ecommerce = {
        checkout: {
          actionField: { step: 3, option: 'Get it Delivered' },
          products: items
        }
      }
      const payload = {
        event: 'confirmLocation_addNewAddress_checkout',
        user_env: this.UTS.getENV() || '',
        value: cart && cart.totalPayNow || '',
        currency: 'AED',
        item: ecommerce || '',
      };
      this.pushDateOnGoogleAnalytics(payload);
    } catch(e){
      this.UTS.log(e);
    }
  }
  async saveLocation_addNewAddress_checkout(cart: any) {
    try{
      let items = [];
      if (cart && cart?.items && cart?.items.length > 0) {
        for (let i = 0; i < cart?.items.length; i++) {
          const r: any = await this.CS.getProductDetails(cart?.items[i]).toPromise().catch((e) => { this.UTS.error(e.error.message); });
          items.push({
            item_id: cart?.items[i].skuId || '',
            item_name: localStorage.getItem("isPrepaid") == 'true' ? localStorage.getItem('title')  : (this.getPlanType(null, cart?.items[i]) || ''),
            currency: 'AED',
            index: i + 1,
            item_brand: cart?.items[i]?.brand ? cart?.items[i]?.brand :"",
            item_category: this.getItemCatType(cart?.items[i]) || '',
            item_category2: (r && r.productName) ? this.getItemCat2Type(r, cart?.items[i]) : cart?.items[i]?.displayName || '',  // Ex: Postpaid: Freedom and New Freedom, eLife: eLife and eLife Lite, Devices: Withing Smarthome: Smart TV or Smart Speakers or Routers or Others.
            item_category3: '',
            item_category4: '',
            item_category5: '',
            item_list_id: localStorage.getItem('subCategory') || '' , // SKUID of Freedom live plans
            item_list_name: localStorage.getItem('title') || '' ,// Plan name
            item_variant: (cart?.items[i] && cart?.items[i].variant) ? cart?.items[i].variant : '',
            price: (cart?.items[i] && cart?.items[i].paymentOptions && cart?.items[i].paymentOptions.price) ? cart?.items[i].paymentOptions.price : (cart?.items[i].price.oneTime) ? cart?.items[i].price.oneTime : '',
            quantity: cart?.items[i].quantity || '',
            contract_type: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : '', //if applicable (12 Months Commitment, No Commitment)
            coupon: (cart.coupon) ? cart.coupon : '', //if applicable
            discount: cart.discount || '', //if applicable
            // item_variant: "green" //if applicable
          });
        }
      }
      const language =
        this.UTS.getLocaleLanguage() &&
          this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : '-AR';
      const payload = {
        event: 'saveLocation_addNewAddress_checkout',
        user_env: this.UTS.getENV() || '',
        value: cart && cart.totalPayNow || '',
        currency: 'AED',
        item: items,
      };
      this.pushDateOnGoogleAnalytics(payload);
    } catch(e){
      this.UTS.log(e);
    }
  }

  async add_review_order(cart: any) {
    try{
      let items = [];
      if (cart && cart?.items && cart?.items.length > 0) {
        for (let i = 0; i < cart?.items.length; i++) {
          const r: any = await this.CS.getProductDetails(cart?.items[i]).toPromise().catch((e) => { this.UTS.error(e.error.message); });
          items.push({
            item_id: cart?.items[i].skuId || '',
            item_name: localStorage.getItem("isPrepaid") == 'true' ? localStorage.getItem('title') : (this.getPlanType(null, cart?.items[i]) || ''),
            currency: 'AED',
            index: i + 1,
            item_brand: cart?.items[i]?.brand ? cart?.items[i]?.brand :"",
            item_category: this.getItemCatType(cart?.items[i]) || '',
            item_category2: (r && r.productName) ? this.getItemCat2Type(r, cart?.items[i]) : cart?.items[i]?.displayName || '', // Ex: Postpaid: Freedom and New Freedom, eLife: eLife and eLife Lite, Devices: Withing Smarthome: Smart TV or Smart Speakers or Routers or Others.
            item_category3: '',
            item_category4: '',
            item_category5: '',
            item_list_id: localStorage.getItem('subCategory') || '' , // SKUID of Freedom live plans
            item_list_name: localStorage.getItem('title') || '' ,// Plan name
            item_variant: (cart?.items[i] && cart?.items[i].variant) ? cart?.items[i].variant : '',
            price: (cart?.items[i] && cart?.items[i].paymentOptions && cart?.items[i].paymentOptions.price) ? cart?.items[i].paymentOptions.price : (cart?.items[i].price.oneTime) ? cart?.items[i].price.oneTime : '',
            quantity: cart?.items[i].quantity || '',
            contract_type: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : '', //if applicable (12 Months Commitment, No Commitment)
            coupon: (cart.coupon) ? cart.coupon : '', //if applicable
            discount: cart.discount || '', //if applicable
            sim_type: cart?.items[i]?.commerceItemSubType ? cart?.items[i]?.commerceItemSubType:"" ,
            esim_device: (cart?.items[i] && cart?.items[i]?.watchEid) ? "Apple Watch." : "Smartphone/Tablets"
            // item_variant: "green" //if applicable
          });
        }
      }
      const language =
        this.UTS.getLocaleLanguage() &&
          this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : '-AR';
      const payload = {
        event: 'postapaid_review_order_old',
        user_env: this.UTS.getENV() || '',
        value: (cart && cart.totalPayNow) ? cart.totalPayNow : 0,
        currency: 'AED',
        item: items || '',
      };
      this.pushDateOnGoogleAnalytics(payload);
    } catch(e){
      this.UTS.log(e);
    }
  }

  async add_payment_info(cart: any) {
    try{
      let items = [];
      if (cart && cart?.items && cart?.items.length > 0) {
        for (let i = 0; i < cart?.items.length; i++) {
          const r: any = await this.CS.getProductDetails(cart?.items[i]).toPromise().catch((e) => { this.UTS.error(e.error.message); });
          items.push({
            item_id: cart?.items[i].skuId || '',
            item_name: cart?.items[i]?.displayName || '',
            currency: 'AED',
            index: i + 1,
            item_brand: cart?.items[i]?.brand ? cart?.items[i]?.brand :"",
            item_category: this.getItemCatType(cart?.items[i]) || '',
            item_category2: (r && r.productName) ? this.getItemCat2Type(r, cart?.items[i]) : cart?.items[i]?.displayName || '', // Ex: Postpaid: Freedom and New Freedom, eLife: eLife and eLife Lite, Devices: Withing Smarthome: Smart TV or Smart Speakers or Routers or Others.
            item_category3: '',
            item_category4: '',
            item_category5: '',
            item_list_id: cart?.items[i]?.productId || '',// SKUID of Freedom live plans
            item_list_name: cart?.items[i]?.parentDisplayName ? cart?.items[i]?.parentDisplayName : cart?.items[i]?.displayName,
            item_variant: (cart?.items[i] && cart?.items[i].variant) ? cart?.items[i].variant : '',
            price: (cart?.items[i] && cart?.items[i].paymentOptions && cart?.items[i].paymentOptions.price) ? cart?.items[i].paymentOptions.price : (cart?.items[i].price.oneTime) ? cart?.items[i].price.oneTime : '',
            quantity: cart?.items[i].quantity || '',
            contract_type: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : '', //if applicable (12 Months Commitment, No Commitment)
            coupon: (cart.coupon) ? cart.coupon : '', //if applicable
            discount: cart.discount || '', //if applicable
            sim_type: cart?.items[i]?.commerceItemSubType ? cart?.items[i]?.commerceItemSubType : "" ,
            esim_device: (cart?.items[i] && cart?.items[i]?.watchEid) ? "Apple Watch." : "Smartphone/Tablets"
            // item_variant: "green" //if applicable
          });
        }
      }
      const language =
        this.UTS.getLocaleLanguage() &&
          this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : '-AR';
      const payload = {
        event: 'add_payment_info',
        user_env: this.UTS.getENV() || '',
        value: (cart && cart.totalPayNow) ? cart.totalPayNow : 0,
        currency: 'AED',
        item: items || '',
      };
      this.pushDateOnGoogleAnalytics(payload);
    } catch(e){
      this.UTS.log(e);
    }
  }

  async purchase(cart: any) {
    try{
      let items = [];
      if (cart && cart?.items && cart?.items.length > 0) {
        for (let i = 0; i < cart?.items.length; i++) {
          const r: any = await this.CS.getProductDetails(cart?.items[i]).toPromise().catch((e) => { this.UTS.error(e.error.message); });
          items.push({
            item_id: cart?.items[i].skuId || '',
            item_name: cart?.items[i]?.displayName || '',
            currency: 'AED',
            index: i + 1,
            item_brand: cart?.items[i]?.brand ? cart?.items[i]?.brand :"",
            item_category: this.getItemCatType(cart?.items[i]) || '',
            item_category2: (r && r.productName) ? this.getItemCat2Type(r, cart?.items[i]) : cart?.items[i]?.displayName || '', // Ex: Postpaid: Freedom and New Freedom, eLife: eLife and eLife Lite, Devices: Withing Smarthome: Smart TV or Smart Speakers or Routers or Others.
            item_category3: '',
            item_category4: '',
            item_category5: '',
            item_list_id: cart?.items[i]?.productId || '',// SKUID of Freedom live plans
            item_list_name: cart?.items[i]?.parentDisplayName ? cart?.items[i]?.parentDisplayName : cart?.items[i]?.displayName,
            item_variant: (cart?.items[i] && cart?.items[i].variant) ? cart?.items[i].variant : '',
            price: (cart?.items[i] && cart?.items[i].paymentOptions && cart?.items[i].paymentOptions.price) ? cart?.items[i].paymentOptions.price : (cart?.items[i].price.oneTime) ? cart?.items[i].price.oneTime : '',
            quantity: cart?.items[i].quantity || '',
            contract_type: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : '', //if applicable (12 Months Commitment, No Commitment)
            coupon: (cart.coupon) ? cart.coupon : '', //if applicable
            discount: cart.discount || '', //if applicable
            sim_type: cart?.items[i].commerceItemSubType ? cart?.items[i].commerceItemSubType :"",
            esim_device: (cart?.items[i] && cart?.items[i]?.watchEid) ? "Apple Watch." : "Smartphone/Tablets"
            // item_variant: "green" //if applicable
          });
        }
      }
      const language =
        this.UTS.getLocaleLanguage() &&
          this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : '-AR';
      const payload = {
        event: 'purchase',
        user_env: this.UTS.getENV() || '',
        value: (cart && cart.totalPayNow) ? cart.totalPayNow : 0,
        currency: 'AED',
        item: items || '',
      };
      this.pushDateOnGoogleAnalytics(payload);
    } catch(e){
      this.UTS.log(e);
    }
  }

  async add_personal_info(cart: any) {
    try{
      let items = [];
      if (cart && cart?.items && cart?.items.length > 0) {
        for (let i = 0; i < cart?.items.length; i++) {
          const r: any = await this.CS.getProductDetails(cart?.items[i]).toPromise().catch((e) => { this.UTS.error(e.error.message); });
          items.push({
            item_id: cart?.items[i].skuId || '',
            item_name: cart?.items[i]?.displayName || '',
            currency: 'AED',
            index: i + 1,
            item_brand: cart?.items[i]?.brand ? cart?.items[i]?.brand :"",
            item_category: this.getItemCatType(cart?.items[i]) || '',
            item_category2: (r && r.productName) ? this.getItemCat2Type(r, cart?.items[i]) : cart?.items[i]?.displayName || '', // Ex: Postpaid: Freedom and New Freedom, eLife: eLife and eLife Lite, Devices: Withing Smarthome: Smart TV or Smart Speakers or Routers or Others.
            item_category3: '',
            item_category4: '',
            item_category5: '',
            item_list_id: cart?.items[i]?.productId || '',// SKUID of Freedom live plans
            item_list_name: cart?.items[i]?.parentDisplayName ? cart?.items[i]?.parentDisplayName : cart?.items[i]?.displayName,
            item_variant: (cart?.items[i] && cart?.items[i].variant) ? cart?.items[i].variant : '',
            price: (cart?.items[i] && cart?.items[i].paymentOptions && cart?.items[i].paymentOptions.price) ? cart?.items[i].paymentOptions.price : (cart?.items[i].price.oneTime) ? cart?.items[i].price.oneTime : '',
            quantity: cart?.items[i].quantity || '',
            contract_type: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : '', //if applicable (12 Months Commitment, No Commitment)
            coupon: (cart.coupon) ? cart.coupon : '', //if applicable
            discount: cart.discount || '', //if applicable
            // item_variant: "green" //if applicable
          });
        }
      }
      const language =
        this.UTS.getLocaleLanguage() &&
          this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : '-AR';
      const payload = {
        event: 'add_personal_info',
        user_env: this.UTS.getENV() || '',
        value: (cart && cart.totalPayNow) ? cart.totalPayNow : 0,
        currency: 'AED',
        item: items || '',
      };
      this.pushDateOnGoogleAnalytics(payload);
    } catch(e){
      this.UTS.log(e);
    }
  }

  async remove_from_cart(cart: any) {
    try{
      let items = [];
      if (cart && cart?.items && cart?.items.length > 0) {
        for (let i = 0; i < cart?.items.length; i++) {
          const r: any = await this.CS.getProductDetails(cart?.items[i]).toPromise().catch((e) => { this.UTS.error(e.error.message); });
          items.push({
            item_id: cart?.items[i].skuId || '',
            item_name: cart?.items[i]?.displayName || '',
            currency: 'AED',
            index: i + 1,
            item_brand: cart?.items[i]?.brand ? cart?.items[i]?.brand :"",
            item_category: this.getItemCatType(cart?.items[i]) || '',
            item_category2: (r && r.productName) ? this.getItemCat2Type(r, cart?.items[i]) : cart?.items[i]?.displayName || '',  // Ex: Postpaid: Freedom and New Freedom, eLife: eLife and eLife Lite, Devices: Withing Smarthome: Smart TV or Smart Speakers or Routers or Others.
            item_category3: '',
            item_category4: '',
            item_category5: '',
            item_list_id: cart?.items[i]?.productId || '',// SKUID of Freedom live plans
            item_list_name: cart?.items[i]?.parentDisplayName ? cart?.items[i]?.parentDisplayName : cart?.items[i]?.displayName,
            item_variant: (cart?.items[i] && cart?.items[i].variant) ? cart?.items[i].variant : '',
            price: (cart?.items[i] && cart?.items[i].paymentOptions && cart?.items[i].paymentOptions.price) ? cart?.items[i].paymentOptions.price : (cart?.items[i].price.oneTime) ? cart?.items[i].price.oneTime : '',
            quantity: cart?.items[i].quantity || '',
            contract_type: (cart?.items[i] && cart?.items[i].contractDuration) ? cart?.items[i].contractDuration : '', //if applicable (12 Months Commitment, No Commitment)
            coupon: (cart.coupon) ? cart.coupon : '', //if applicable
            discount: cart.discount || '', //if applicable
            sim_type: cart?.items[i]?.commerceItemSubType? cart?.items[i]?.commerceItemSubType :"",
            esim_device: (cart?.items[i] && cart?.items[i]?.watchEid) ? "Apple Watch." : "Smartphone/Tablets"
            // item_variant: "green" //if applicable
          });
        }
      }
      const language =
        this.UTS.getLocaleLanguage() &&
          this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : '-AR';
      const payload = {
        event: 'remove_from_cart',
        user_env: this.UTS.getENV() || '',
        value: (cart && cart.totalPayNow) ? cart.totalPayNow : 0,
        currency: 'AED',
        item: items || '',
      };
      this.pushDateOnGoogleAnalytics(payload);
    } catch(e){
      this.UTS.log(e);
    }
  }


   async removeFromCart(cart: any,index:any='') {
    try{
      let products = [];
      const productType: any =  cart && cart?.productType == 'MOBILE_POSTPAID' ? 'Postpaid' : cart && cart?.productType == 'MOBILE_PREPAID' ? 'Prepaid' : '';
      // const productData = JSON.parse(localStorage.getItem('ProductData'));
      if (cart) {
        const productData: any = await this.CS.getProductDetails(cart).toPromise().catch((e) => { this.UTS.error(e.error.message); });
          products.push({
            name: cart?.displayName || '',
            id: cart?.productId || '',
            price: cart?.price?.oneTime || '',
            category:this.getItemCatType(cart) || '',
            brand:cart?.brand || '',
            variant:'',
            list:cart?.landingFrom,
            position:index,
            dimension1: cart?.contractDuration || '',
            dimension2:  "", //String - Capacity 2 Bundle (if available)
            dimension3: "", //String - Size (if available)
            dimension4: "", //String - Color 1 (if available)
            dimension5: '', //String - Color 2 Bundle (if available)
            dimension6: "", //String - Strap Type (if available)
            dimension7: '', //String - Strap Color (if available)
            dimension8: '', //String - Connectivity (if available)
            dimension9: '', //String - Payment Method (if available)
            dimension10: '', //String - Number Selection Option (if available)
            dimension11: cart?.accountNumberSelected, //String - Number Selected (if available)
            dimension12: '', //String - Plan Selected (if available)
            dimension13: '', //String - Add-On Name 1 (if available)
            dimension14: '', //String - Add-On Name 2 (if available)
            dimension15: '', //String - Add-On Payment Option 1 (if available)
            dimension16: '', //String - Add-On Payment Option 2 (if available)
            dimension17: '', //String - Availability (if available)
            dimension18: cart?.contractDuration || '', //String - SIM Card option (if available)
            dimension25: productData?.productName || ''
          });
      }
      const payload = {
        event: 'removeFromCart',
        user_env: this.UTS.getENV(),
        ecommerce:{
          currencyCode:'AED',
          remove:{
            actionField:{action:'remove',list:cart?.landingFrom},
            products:products
          }
        }
      };
      this.pushDateOnGoogleAnalytics(payload);
    } catch(e){
      this.UTS.log(e);
    }
  }

  private pushDateOnGoogleAnalytics(P: any) {
    try {

     //  window.dataLayer.push(P);
    this.GTMS.pushTag(P);
    } catch (e) {

    }
  }
  checkout(event, F: string[]) {
    const language = (this.UTS.getLocaleLanguage() && this.UTS.getLocaleLanguage().toLowerCase() == 'en') ? '' : '-AR';
    const payload = {
      event: 'checkout',
      user_env: this.UTS.getENV(),
      eventCategory: 'checkout_now' + language,
      eventAction: event || '',
      eventLabel: F || '',
    };
    this.pushDateOnGoogleAnalytics(payload);
  }
  CJSteps(cart: any, A: string) {
    let numberOfItemsInCart = cart?.numberOfItemsInCart;
    let itemNames = (cart?.items?.length > 0)? cart?.items?.map(x => (x.commerceItemCategory)?x.commerceItemCategory:x.displayName).join('_'): '';

    try {
      const label = A && A != '' ? A.split(' ').join('_') : '';
      const specifiedDevice =
        this.UTS.getENV() == 'mobile'
          ? this.UTS.getMobileOperatingSystem()
          : '';
      let language =
        this.UTS.getLocaleLanguage() &&
        this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : '-AR';
      language = language ? language : 'en';
      const payload = {
        user_env: this.UTS.getENV(),
        information: this.UTS.getJSID(),
        event: 'customer_journey',
        eventCategory:
          'customer_journey_tracking_flow_shoppingcart_' + itemNames?.toLocaleLowerCase(),
        eventLabel:
          numberOfItemsInCart +
          '_' +
          itemNames?.toLocaleLowerCase() +
          '_' +
          label +
          '_' +
          this.UTS.getENV().toLocaleLowerCase() +
          '_' +
          specifiedDevice?.toLocaleLowerCase() +
          '_' +
          language?.toLocaleLowerCase(),
        eventAction: itemNames?.toLocaleLowerCase() + '_' + label,
        clicked_url : document.URL,
      };
      if(this.APINITS?.environmentConfig?.IS_ACTIVITY_LOGGING_ENABLED == 'TRUE'){
        this.UTS.logActivity(payload);
      }
      this.pushDateOnGoogleAnalytics(payload);
    } catch (e) {
      this.UTS.log(e);
    }
  }
  CJStepsFrontendLog(stepName: any, details: any) {
    try {
      const specifiedDevice =
        this.UTS.getENV() == 'mobile'
          ? this.UTS.getMobileOperatingSystem()
          : '';
      let language =
        this.UTS.getLocaleLanguage() &&
        this.UTS.getLocaleLanguage().toLowerCase() == 'en'
          ? ''
          : '-AR';
      language = language ? language : 'en';
      const payload = {
        user_env: this.UTS.getENV(),
        information: this.UTS.getJSID(),
        event: 'customer_journey_checkout',
        eventCategory:
          'customer_journey_tracking_flow_checkout_' + stepName,
        eventLabel: 'cusomer_journey_checkout_' + stepName + +'_' + specifiedDevice?.toLocaleLowerCase(),
        eventAction: (details?.shippingAddress?.latitude + '_'
        + details?.shippingAddress?.emirate + '_'
        + details?.shippingAddress?.firstName)
        || '',
        clicked_url : document.URL,
      };
      if(this.APINITS?.environmentConfig?.IS_ACTIVITY_LOGGING_ENABLED == 'TRUE'){
        this.UTS.logActivity(payload);
      }
    } catch (e) {
      this.UTS.log(e);
    }
  }
  postpaid_tracking(payload)
  {
    this.pushDateOnGoogleAnalytics(payload);
  }

  itemTracking(items,event,cart:any,stitchFields?)
  {
    try{
      let userAccountType;
      let planName;
      if (sessionStorage.getItem('planName')) {
        planName = sessionStorage.getItem('planName');
      }
      if (localStorage.getItem('currentUserAccountType')) {
        userAccountType = localStorage.getItem('currentUserAccountType');
      }
      const userInfo = (this.UTS.getUserId())? this.UTS.getUserId():'';
      const stitchings = ['utm_source', 'utm_campaign', 'utm_medium', 'entry_point'];
      let extrasList=[];
      let extras=[];
      if (
        localStorage.getItem('extras') != 'undefined' &&
        localStorage.getItem('extras') != null
      )
      {
        extrasList=JSON.parse(localStorage.getItem('extras'));

      }
      let cartItems=[];
      if(items!=null&&items.length>0)
      {
       items.forEach(element => {
         let item=  {
           item_id:element?.skuId,// Capture the SKU ID of the plan
           item_name: element?.displayName,
           device_type: this.UTS.getENV(),//App
           coupon: (cart.coupon) ? cart.coupon : 'Nil', //if applicable
           discount: cart.discount || 'Nil', //if applicable
           index: 1,
           item_brand: element?.brand ? element?.brand:"Etisalat",
           item_category: this.getItemCatType(element) || '',
           item_list_id: element?.productId || '' , // SKUID of Freedom live plans
           item_list_name: element?.parentDisplayName ? element?.parentDisplayName : element?.displayName ,// Plan name
           price: element?.paymentOptions?.price?element?.paymentOptions?.price:element?.price?.oneTime, //Price of the plan
           currency: 'AED', // Currency
           quantity: '1',
           user_id:  userInfo ||'', // Capture user id . No PII data.
           sim_type: element?.commerceItemSubType ? element?.commerceItemSubType : "",
           esim_device: (element && element?.watchEid) ? "Apple Watch." : "Smartphone/Tablets",
           current_account_type: userAccountType || '', // Prepaid
           current_plan_name: planName || '' // dynamic value
           }
           if(element.hasOwnProperty('productType'))
           {
            if((element?.productType.toLowerCase().includes('prepaid'))&& (event != 'view_item'))
            {
             let key = 'plan_duration';
             item[key]=element?.contractDuration? element?.contractDuration:'nil';
            }
         }
         //home wireless price
         if (element.hasOwnProperty('displayName')) {
           if (element?.displayName == 'Home Wireless Premium' || element?.displayName == 'Home Wireless Advance') {
             item.price = element?.price?.rental;
             if (element?.addons != null && element?.addons.length > 0) {
               element?.addons.forEach((value, index) => {
                 const key = `router${index + 1}`;
                 item[key] = value.displayName
               });
             }
           }
         }
         //visitor line insurance
         if (element?.hasOwnProperty('displayName')) {
           if (element?.displayName?.toLowerCase()?.includes('visitor')) {
             if (element?.addons != null && element?.addons?.length > 0) {
               if(cart && cart?.totalPayNow ){
                item.price = cart?.totalPayNow;
               }
               element?.addons?.forEach((value, index) => {
                 if (value?.parentDisplayName == 'Travel Insurance') {
                   const key = `insurance`;
                   item[key] = value?.displayName
                 }
               });
             }
           }
         }

         //smart pay configuration
         if (element?.paymentOptions?.id == '-1') {
           const key2 = 'payment_tenure';
           const key3 = 'smartpay';
           item[key2] = 'One time';
           item[key3] = 'No'
         }
         else if (element?.paymentOptions?.id != '-1') {
           const key2 = 'payment_tenure';
           const key3 = 'smartpay';
           if (element?.paymentOptions?.duration) {
             item[key2] = element?.paymentOptions?.duration + ' ' + 'Months' || '';
             item[key3] = 'Yes';
             const key4 = 'payment_type';
             if (element?.setupAutoPay == true) {
               item[key4] = 'Set up Autopay';
             }
             else if (element?.setupAutoPay == false) {
               item[key4] = 'Do not set up Autopay';
             }
             const key5 = 'smartpay_account';
             if (element?.newPostpaidPlan?.skuId) {
               item[key5] = 'Buy a new plan';
             }
             else if (element?.isExistingAccountNumber == true) {
               item[key5] = 'Link to existing plan';
             }
           }
         }
           let index=0;
           extras=  extrasList.filter(x=>x?.skuId==element?.skuId)[0]?.extras;
           if(extras!=null)
           {
             if(extras.length>0)
             {
              extras.forEach(x => {
                index++;
               let key="item_extras"+ index;
               let value=x.label;

               item[key]=value;
              });
             }  else{
              let key='item_extras1';
              let key2='item_extras2'

              item[key]='nil';
              item[key2]='nil';
             }

           }
           else if (element?.dynamicAttributesExtendedEn!=null)
           {
            element?.dynamicAttributesExtendedEn.forEach(x => {
              index++;
             let key="item_extras"+ index;
             let value=x.label;

             item[key]=value;
            });
           }
           else{
            let key='item_extras1';
            let key2='item_extras2'

            item[key]='nil';
            item[key2]='nil';
           }

           cartItems.push(item);

       });

      }


      let data={
        event:event,
        ecommerce:{
          shipping_tier:'Courier',
          items:cartItems
        }
      }
      this.pushDateOnGoogleAnalytics(data);

  } catch(e){
    this.UTS.log(e);
  }
  }
   purchaseTracking(cart,event, id,email)
  {
    try{
      let items= cart?.items;
      let totalPay = '';
      if(cart && cart?.totalPayNow){
        totalPay = cart?.totalPayNow
      }
      const userInfo = (this.UTS.getUserId())? this.UTS.getUserId():'';
      let extrasList=[];
      let extras=[];
      let paymentType ='';
      if (
        localStorage.getItem('paymentMethod') != 'undefined' &&
        localStorage.getItem('paymentMethod') != null
      )
      {
        paymentType=(localStorage.getItem('paymentMethod'));

      }
      if (
        localStorage.getItem('extras') != 'undefined' &&
        localStorage.getItem('extras') != null
      )
      {
        extrasList=JSON.parse(localStorage.getItem('extras'));

      }
      let cartItems=[];
      if(items!=null&&items.length>0)
      {
       items.forEach(element => {
         let item=  {
           item_id:element?.skuId,// Capture the SKU ID of the plan
           item_name: element?.displayName,
           device_type: this.UTS.getENV(),//App
           coupon: 'Nil', //if applicable
           discount: 'Nil', //if applicable
           index: 1,
           item_brand: element.brand?element.brand:"Etisalat",
           item_category: this.getItemCatType(element) || '',
           item_list_id: element?.productId || '' , // SKUID of Freedom live plans
           item_list_name: element?.parentDisplayName ? element?.parentDisplayName : element?.displayName ,// Plan name
           price: element?.paymentOptions?.price?element?.paymentOptions?.price:element?.price?.oneTime, //Price of the plan
           payment_type:paymentType,
           sim_type: element?.commerceItemSubType ? element?.commerceItemSubType : "",
           currency: 'AED', // Currency
           quantity: '1',
           user_id:  userInfo ||'' // Capture user id . No PII data.
           }
           if(element.hasOwnProperty('productType'))
           {
            if((element?.productType.toLowerCase().includes('prepaid'))&& (event != 'view_item'))
            {
             let key = 'plan_duration';
             item[key]=element?.contractDuration? element?.contractDuration:'nil';
            }
           }
         //home wireless price
         if (element.hasOwnProperty('displayName')) {
          if (element?.displayName == 'Home Wireless Premium' || element?.displayName == 'Home Wireless Advance') {
            item.price = element?.price?.rental;
            if (element?.addons != null && element?.addons.length > 0) {
              element?.addons.forEach((value, index) => {
                const key = `router${index + 1}`;
                item[key] = value.displayName
              });
            }
          }
         }
         //visitor line insurance
         if (element?.hasOwnProperty('displayName')) {
           if (element?.displayName?.toLowerCase()?.includes('visitor')) {
             if (element?.addons != null && element?.addons?.length > 0) {
               item.price = totalPay;
               element?.addons?.forEach((value, index) => {
                 if (value?.parentDisplayName == 'Travel Insurance') {
                   const key = `insurance`;
                   item[key] = value?.displayName
                 }
               });
             }
           }
         }

         //smart pay configuration
         if (element?.paymentOptions?.id == '-1') {
           const key2 = 'payment_tenure';
           const key3 = 'smartpay';
           item[key2] = 'One time';
           item[key3] = 'No'
         }
         else if (element?.paymentOptions?.id != '-1') {
           const key2 = 'payment_tenure';
           const key3 = 'smartpay';
           if (element?.paymentOptions?.duration) {
             item[key2] = element?.paymentOptions?.duration + ' ' + 'Months' || '';
             item[key3] = 'Yes';
             const key4 = 'payment_type';
             if (element?.setupAutoPay == true) {
               item[key4] = 'Set up Autopay';
             }
             else if (element?.setupAutoPay == false) {
               item[key4] = 'Do not set up Autopay';
             }
             const key5 = 'smartpay_account';
             if (element?.newPostpaidPlan?.skuId) {
               item[key5] = 'Buy a new plan';
             }
             else if (element?.isExistingAccountNumber == true) {
               item[key5] = 'Link to existing plan';
             }
           }
         }

           let index=0;
           extras=  extrasList.filter(x=>x?.skuId==element?.skuId)[0]?.extras;
           if(extras!=null)
           {
             if(extras.length>0)
             {
              extras.forEach(x => {
                index++;
               let key="item_extras"+ index;
               let value=x.label;

               item[key]=value;
              });
             } else{
              let key='item_extras1';
              let key2='item_extras2'

              item[key]='nil';
              item[key2]='nil';
             }

           }
           else if (element?.dynamicAttributesExtendedEn!=null)
           {
            element?.dynamicAttributesExtendedEn.forEach(x => {
              index++;
             let key="item_extras"+ index;
             let value=x.label;

             item[key]=value;
            });
           } else{
            let key='item_extras1';
            let key2='item_extras2'

            item[key]='nil';
            item[key2]='nil';
           }
           cartItems.push(item);

       });

      }


         let data={
           event:event,
           ecommerce:{
            currency:'AED' ,
            value: (cart && cart.totalPayNow) ? cart.totalPayNow : 0,
            tax: '0',
            shipping: '0',
            affiliation: 'My Etisalat Website', // My Etisalat App
            transaction_id: id, // Transaction id
            coupon: 'Nil',
             items:cartItems
           }
         }
         this.pushDateOnGoogleAnalytics(data);
         this.MSFE.Purchase(data,email);
         localStorage.removeItem('subCategory');
  } catch(e){
    this.UTS.log(e);
  }
  }
  paymentTracking(event,paymentType)
  {
    try{
      const userInfo = (this.UTS.getUserId())? this.UTS.getUserId():'';
      let extrasList=[];
      let extras=[];
      if (
        localStorage.getItem('extras') != 'undefined' &&
        localStorage.getItem('extras') != null
      )
      {
        extrasList=JSON.parse(localStorage.getItem('extras'));

      }
      let cartItems=[];
      let items=[];
      let totalPay = '';
      if (
        localStorage.getItem('CS') != 'undefined' &&
        localStorage.getItem('CS') != null
      ) {
        let cart = JSON.parse(localStorage.getItem('CS'));
        items=cart?.items;
        if(cart && cart?.totalPayNow){
          totalPay = cart?.totalPayNow
        }
      }
      if(items!=null&&items.length>0)
      {
       items.forEach(element => {
         let item=  {
           item_id:element?.skuId,// Capture the SKU ID of the plan
           item_name:element?.displayName,
           device_type: this.UTS.getENV(),//App
           coupon: "nil", // Capture the coupon value if any else Nil
           discount: "nil", // Capture the discounted value if any else Nil
           index: 1,
           item_brand: element?.brand ? element.brand:"Etisalat",
           item_category: this.getItemCatType(element) || '',
           item_list_id: element?.productId || '' , // SKUID of Freedom live plans
           item_list_name: element?.parentDisplayName ? element?.parentDisplayName : element?.displayName ,// Plan name
           price: element?.paymentOptions?.price?element?.paymentOptions?.price:element?.price?.oneTime, //Price of the plan
           sim_type: element?.commerceItemSubType ? element?.commerceItemSubType : "",
           currency: 'AED', // Currency
           quantity: '1',
           user_id:  userInfo ||''// Capture user id . No PII data.
           }
           if(element.hasOwnProperty('productType')){


           if((element?.productType.toLowerCase().includes('prepaid'))&& (event != 'view_item'))
           {
            let key = 'plan_duration';
            item[key]=element?.contractDuration? element?.contractDuration:'nil';
           }
          }
         //home wireless price
         if (element.hasOwnProperty('displayName')) {
          if (element?.displayName == 'Home Wireless Premium' || element?.displayName == 'Home Wireless Advance') {
            item.price = element?.price?.rental;
            if (element?.addons != null && element?.addons.length > 0) {
              element?.addons.forEach((value, index) => {
                const key = `router${index + 1}`;
                item[key] = value.displayName
              });
            }
          }
         }
         //visitor line insurance
         if (element?.hasOwnProperty('displayName')) {
           if (element?.displayName?.toLowerCase()?.includes('visitor')) {
             if (element?.addons != null && element?.addons?.length > 0) {
              item.price = totalPay;
               element?.addons?.forEach((value, index) => {
                 if (value?.parentDisplayName == 'Travel Insurance') {
                   const key = `insurance`;
                   item[key] = value?.displayName
                 }
               });
             }
           }
         }
         //smart pay configuration
         if (element?.paymentOptions?.id == '-1') {
           const key2 = 'payment_tenure';
           const key3 = 'smartpay';
           item[key2] = 'One time';
           item[key3] = 'No'
         }
         else if (element?.paymentOptions?.id != '-1') {
           const key2 = 'payment_tenure';
           const key3 = 'smartpay';
           if (element?.paymentOptions?.duration) {
             item[key2] = element?.paymentOptions?.duration + ' ' + 'Months' || '';
             item[key3] = 'Yes';
             const key4 = 'payment_type';
             if (element?.setupAutoPay == true) {
               item[key4] = 'Set up Autopay';
             }
             else if (element?.setupAutoPay == false) {
               item[key4] = 'Do not set up Autopay';
             }
             const key5 = 'smartpay_account';
             if (element?.newPostpaidPlan?.skuId) {
               item[key5] = 'Buy a new plan';
             }
             else if (element?.isExistingAccountNumber == true) {
               item[key5] = 'Link to existing plan';
             }
           }
         }
           let index=0;
           extras=  extrasList.filter(x=>x?.skuId==element?.skuId)[0]?.extras;
           if(extras!=null)
           {
             if(extras.length>0)
             {
              extras.forEach(x => {
                index++;
               let key="item_extras"+ index;
               let value=x.label;

               item[key]=value;
              });
             } else{
              let key='item_extras1';
              let key2='item_extras2'

              item[key]='nil';
              item[key2]='nil';
             }

           }
           else if (element?.dynamicAttributesExtendedEn!=null)
           {
            element?.dynamicAttributesExtendedEn.forEach(x => {
              index++;
             let key="item_extras"+ index;
             let value=x.label;

             item[key]=value;
            });
           } else{
            let key='item_extras1';
            let key2='item_extras2'

            item[key]='nil';
            item[key2]='nil';
           }
           cartItems.push(item);

       });
      }


         let data={
           event:event,
           payment_type:paymentType,
           ecommerce:{
             items:cartItems
           }
         }
         this.pushDateOnGoogleAnalytics(data);

  } catch(e){
    this.UTS.log(e);
  }
  }
  checkoutCTATracking(items,event)
  {
    try{
      const userInfo = (this.UTS.getUserId())? this.UTS.getUserId():'';
      let cartItems=[];
      let currentUserAccountType;
      if (
        localStorage.getItem('currentUserAccountType') != 'undefined' &&
        localStorage.getItem('currentUserAccountType') != null
      ) {
        currentUserAccountType =localStorage.getItem('currentUserAccountType');

      }
      if(items!=null&&items.length>0)
      {
       items.forEach(element => {
         let item=
           {
            'entry_point' : element?.landingFrom,
            'current_account_type': currentUserAccountType,
            'current_plan_name': element?.displayName,
            'section': window?.location?.pathname,
            'sub-section': window?.location?.pathname,
            'Info': element?.displayName,
           'user_type': this.isLoginUser() ? 'Loggedin' : 'Guest',
            'login_type': 'otp' ,
            'user_id': userInfo ||'' ,
            'language':  this.UTS.getLocaleLanguage(),
            'sku_id': element?.skuId ,//
            'device_type': this.UTS.getENV()
           }
           cartItems.push(item);

       });
      }


         let data={
           event:event,
           ecommerce:{
             shipping_tier:'Courier',
             items:cartItems
           }
         }
         this.pushDateOnGoogleAnalytics(data);
  } catch(e){
    this.UTS.log(e);
  }
  }

  onMapInteraction()
  {
    try{
      const userInfo = (this.UTS.getUserId())? this.UTS.getUserId():'';

      let currentUserAccountType;
      if (
        localStorage.getItem('currentUserAccountType') != 'undefined' &&
        localStorage.getItem('currentUserAccountType') != null
      ) {
        currentUserAccountType = localStorage.getItem('currentUserAccountType');

      }
    let item=  {
        'event':'checkout_cta_click',
        'entry_point' :window.location.pathname,
        'current_account_type': currentUserAccountType?currentUserAccountType:'nil',
        'current_plan_name': 'nil',
        'section': window.location.pathname,
        'sub-section': window.location.pathname,
        'Info': 'nil',
       'user_type': this.isLoginUser() ? 'Loggedin' : 'Guest',
        'login_type': 'otp' ,
        'user_id': userInfo ||'' ,
        'language':  this.UTS.getLocaleLanguage(),
        'sku_id':'nil',//
        'device_type': this.UTS.getENV()
       }

      this.pushDateOnGoogleAnalytics(item);
    }catch(e)
    {
      console.log(e);
    }
  }
  removeFromCartItemTracking(items,event)
  {
    try{
      const userInfo = (this.UTS.getUserId())? this.UTS.getUserId():'';
    let extrasList=[];
     let extras=[];
     if (
       localStorage.getItem('extras') != 'undefined' &&
       localStorage.getItem('extras') != null
     )
     {
       extrasList=JSON.parse(localStorage.getItem('extras'));
     extras=  extrasList.filter(x=>x?.skuId==items?.skuId)[0]?.extras;
     }
         let item=  {
           item_id:items?.skuId,// Capture the SKU ID of the plan
           item_name:items?.displayName,
           device_type: this.UTS.getENV(),//App
           coupon: "nil", // Capture the coupon value if any else Nil
           discount: "nil", // Capture the discounted value if any else Nil
           index: 1,
           item_brand: items.brand?items.brand:"Etisalat",
           item_category:this.getItemCatType(items) || '',

           item_list_id: items?.productId || '' , // SKUID of Freedom live plans
           item_list_name: items?.parentDisplayName ? items?.parentDisplayName : items?.displayName ,// Plan name
           price: items?.paymentOptions?.price?items?.paymentOptions?.price:items?.price?.oneTime, //Price of the plan
           currency: 'AED', // Currency
           quantity: '1',
           user_id:  userInfo ||'' // Capture user id . No PII data.
           }
           if(items.hasOwnProperty('productType'))
           {
            if((items?.productType.toLowerCase().includes('prepaid'))&& (event != 'view_item'))
            {
             let key = 'plan_duration';
             item[key]=items?.contractDuration? items?.contractDuration:'nil';
            }
           }
         //home wireless price
         if (items.hasOwnProperty('displayName')) {
          if (items?.displayName == 'Home Wireless Premium' || items?.displayName == 'Home Wireless Advance') {
            item.price = items?.price?.rental;
            if (items?.addons != null && items?.addons.length > 0) {
              items?.addons.forEach((value, index) => {
                const key = `router${index + 1}`;
                item[key] = value.displayName
              });
            }
          }
        }
      //smart pay configuration
      if (items?.paymentOptions?.id == '-1') {
        const key2 = 'payment_tenure';
        const key3 = 'smartpay';
        item[key2] = 'One time';
        item[key3] = 'No'
      }
      else if (items?.paymentOptions?.id != '-1') {
        const key2 = 'payment_tenure';
        const key3 = 'smartpay';
        if (items?.paymentOptions?.duration) {
          item[key2] = items?.paymentOptions?.duration + ' ' + 'Months' || '';
          item[key3] = 'Yes';
          const key4 = 'payment_type';
          if (items?.setupAutoPay == true) {
            item[key4] = 'Set up Autopay';
          }
          else if (items?.setupAutoPay == false) {
            item[key4] = 'Do not set up Autopay';
          }
          const key5 = 'smartpay_account';
          if (items?.newPostpaidPlan?.skuId) {
            item[key5] = 'Buy a new plan';
          }
          else if (items?.isExistingAccountNumber == true) {
            item[key5] = 'Link to existing plan';
          }
        }
      }
           let index=0;
           if(extras!=null)
           {
             if(extras.length>0)
             {
              extras.forEach(element => {
                index++;
               let key="item_extras"+ index;
               let value=element.label;

               item[key]=value;
              });
             } else{
              let key='item_extras1';
              let key2='item_extras2'

              item[key]='nil';
              item[key2]='nil';
             }

           }
           else if (items?.dynamicAttributesExtendedEn!=null)
           {
            items?.dynamicAttributesExtendedEn.forEach(element => {
              index++;
             let key="item_extras"+ index;
             let value=element.label;

             item[key]=value;
            });
           }
           else{
            let key='item_extras1';
            let key2='item_extras2'

            item[key]='nil';
            item[key2]='nil';
           }

         let data={
           event:event,
           ecommerce:{
             shipping_tier:'Courier',
             items:item
           }
         }
         this.pushDateOnGoogleAnalytics(data);

  } catch(e){
    this.UTS.log(e);
  }
  }
  isLoginUser() : boolean{
    const isLogin = localStorage.getItem('ISLOGIN');
    if(isLogin){
      return true;
    }
    else{
      return false;
    }
 }

 verificationTracking(section)
 {
   try{
     const userInfo = (this.UTS.getUserId())? this.UTS.getUserId():'';
     let cartItems=[];
     let currentUserAccountType;
     let items=[];
     if (
       localStorage.getItem('currentUserAccountType') != 'undefined' &&
       localStorage.getItem('currentUserAccountType') != null
     ) {
       currentUserAccountType = localStorage.getItem('currentUserAccountType');

     }
     if (
      localStorage.getItem('CS') != 'undefined' &&
      localStorage.getItem('CS') != null
    ) {
      let cart = JSON.parse(localStorage.getItem('CS'));
      items=cart?.items;

    }
     if(items!=null&&items.length>0)
     {
      items.forEach(element => {
        let item=
          {

           'entry_point' : element?.landingFrom,
           'current_account_type': currentUserAccountType,
           'current_plan_name': element?.displayName,
           'section': window.location.pathname,
           'sub-section': section,
           'Info': element.displayName,
          'user_type': this.isLoginUser() ? 'Loggedin' : 'Guest',
           'login_type': 'otp' ,
           'user_id': userInfo ||'' ,
           'language':  this.UTS.getLocaleLanguage(),
           'sku_id': element?.skuId ,//
           'device_type': this.UTS.getENV()
          }
          cartItems.push(item);

      });
     }


        let data={
          event:'checkout_verify_number',
          ecommerce:{
            shipping_tier:'Courier',
            items:cartItems
          }
        }
        this.pushDateOnGoogleAnalytics(data);

 } catch(e){
   this.UTS.log(e);
 }
 }
 trackScreen(prevUrl)
 {
   let data={
     "current_url": window.location.href,
     "previous_url":prevUrl,
     "previous_screen_time":'60 seconds on average',
     event:'content_view'
   }
   this.pushDateOnGoogleAnalytics(data);
 }

 async premiumProductDetailImpression(index: number = 0, cart: any,event : string, userInfo: any) {
    try {
      let temp: any = {};
      let products = [];
      // const userInfo = (this.UTS.getUserId())? this.UTS.getUserId():'';
      // if (cart && cart?.items && cart?.items.length > 0) {
      //   for (let i = 0; i < cart?.items.length; i++) {
      //     const r: any = await this.CS.getProductDetails(cart?.items[i]).toPromise().catch((e) => { this.UTS.error(e.error.message); });

          temp.item_name =  cart?.displayName || ''; //String - Product Name
          temp.item_id = cart?.skuId || ''; //String - Product ID
          temp.item_brand = cart?.brand ? cart?.brand:"",
          temp.quantity = '1';
          temp.index = index + 1;
          temp.item_category = this.getItemCatType(cart) || '',
          temp.item_list_id = (cart?.productId)? cart?.productId : '';
          temp.item_list_name =  '';
          temp.coupon = (cart?.coupon) ? cart.coupon : '', //if applicable
          temp.discount = cart?.discount|| '';
          temp.price = (cart?.price) ? cart.price : (cart.oneTime) ? cart.price.oneTime : '', //String - Product Price
          temp.currency = this.currency || '';
          temp.user_id = userInfo?.id || '';
          // for (let k = 0; k < sku?.dynamicAttributesExtendedEn?.length; k++) {

          //   temp['item_extras' + (k + 1)] = sku.dynamicAttributesExtendedEn[k].label || '';
          // }
          temp.device_type = this.UTS.getENV(),
            products.push(temp);
      //   }
      // }
      const payload = {
        event: event,
        ecommerce: {
          items: products
        },
      };
      this.pushDateOnGoogleAnalytics(payload);
    } catch (e) {
      this.UTS.log(e);
    }
  }

  postpaidEsimInstall(eventname,devicetype: any,activate: any)
 {
  try{
    const userInfo = (this.UTS.getUserId())? this.UTS.getUserId():'';
    const language =this.UTS.getLocaleLanguage() && this.UTS.getLocaleLanguage().toLowerCase() == 'en'? '': '-AR';
    let cartItems=[];
      let items=[];
      if (
        localStorage.getItem('CS') != 'undefined' &&
        localStorage.getItem('CS') != null
      ) {
        let cart = JSON.parse(localStorage.getItem('CS'));
        items=cart?.items;
        console.log(cart);

      }
    let data={
     "current_account_type:": "",
     "current_plan_name":items && items[0]?.displayName ? items[0]?.displayName :"",
     "plan_selected":items && items[0]?.displayName ? items[0]?.displayName :"",
     "section":devicetype,
     "eSim":activate ? "Smart Phone /Device":"Apple watch",
     "user_id": userInfo,
     "user_device": activate ? "Smart Phone /Device":"Apple watch",
     "language": language,
     "sku_id":items && items[0]?.skuId ? items[0]?.skuId : "",
     event:'postpaid_esim_install'
   }
   this.pushDateOnGoogleAnalytics(data);
} catch(e){
this.UTS.log(e);
}
 }

  VisitorLineEsimInstall(eventname, devicetype: any) {
    try {
      const userInfo = (this.UTS.getUserId()) ? this.UTS.getUserId() : '';
      const language = this.UTS.getLocaleLanguage() && this.UTS.getLocaleLanguage().toLowerCase() == 'en' ? '' : '-AR';
      let userAccountType;
      let planName;
      if (sessionStorage?.getItem('planName')) {
        planName = sessionStorage.getItem('planName');
      }
      if (localStorage?.getItem('currentUserAccountType')) {
        userAccountType = localStorage.getItem('currentUserAccountType');
      }
      let items = [];
      if (
        localStorage.getItem('CS') != 'undefined' &&
        localStorage.getItem('CS') != null
      ) {
        let cart = JSON.parse(localStorage.getItem('CS'));
        items = cart?.items;
      }
      let data = {
        "current_account_type:": planName || "",
        "current_plan_name": userAccountType || "",
        "plan_selected": items && items[0] && items[0]?.displayName ? items[0]?.displayName : "",
        "section": devicetype,
        "user_id": userInfo,
        "language": language,
        "sku_id": items && items[0] && items[0]?.skuId ? items[0]?.skuId : "",
        'event': eventname
      }
      this.pushDateOnGoogleAnalytics(data);
    } catch (e) {
      this.UTS.log(e);
    }
  }
  checkoutOptimizationTracking(event, items, cart, section, info, screen, paymentMethod?, sub_section?, rechargeAmount?,stitchFields?) {
    try {
      let userAccountType;
      let planName;
      let currentAccount;
      if (sessionStorage.getItem('planName')) {
        planName = sessionStorage.getItem('planName');
      }
      if (localStorage.getItem('currentUserAccountType')) {
        userAccountType = localStorage.getItem('currentUserAccountType');
      }
      if (localStorage.getItem('currentAccount') && localStorage.getItem('currentAccount') != 'undefined' && localStorage.getItem('currentAccount') != null) {
        currentAccount = JSON.parse(localStorage.getItem('currentAccount'));
      }
      if(!userAccountType && currentAccount && currentAccount.accountType ){
        userAccountType = currentAccount.accountType;
      }
      if(!planName && currentAccount && currentAccount.basePackageDescription ){
        planName = currentAccount.basePackageDescription;
      }
      const userInfo = (this.UTS.getUserId()) ? this.UTS.getUserId() :  this.UTS.getUserInfo()?.userId;
      const stitchings = ['utm_source', 'utm_campaign', 'utm_medium', 'entry_point'];
      let extrasList = [];
      let extras = [];
      if (localStorage.getItem('extras') != 'undefined' && localStorage.getItem('extras') != null) {
        extrasList = JSON.parse(localStorage.getItem('extras'));
      }
      let cartItems = [];
      if (items != null && items.length > 0) {
        items.forEach((element,elementIndex) => {
          let item = {
            item_id: element?.skuId,// Capture the SKU ID of the plan
            item_name: element?.displayName,
            coupon: (cart?.coupon) ? cart.coupon : 'Nil', //if applicable
            discount: cart?.discount ? cart?.discount : 'Nil', //if applicable
            index: elementIndex + 1,
            item_brand: element?.brand ? element?.brand : "Etisalat",
            item_category: this.getItemCatType(element) || '',
            item_list_id: element?.productId || '', // SKUID of Freedom live plans
            item_list_name: element?.parentDisplayName ? element?.parentDisplayName : element?.displayName,// Plan name
            price: element?.paymentOptions?.price ? element?.paymentOptions?.price : element?.price?.oneTime, //Price of the plan
            currency: 'AED', // Currency
            quantity: '1',
            sim_type: element?.commerceItemSubType ? element?.commerceItemSubType : "",
            entry_point: window.location.pathname || '',
            recharge_amount: cart?.totalRechargeAmount ? cart?.totalRechargeAmount: "",
          }
          if (element.hasOwnProperty('productType')) {
            if ((element?.productType.toLowerCase().includes('prepaid')) && (event != 'view_item')) {
              let key = 'plan_duration';
              item[key] = element?.contractDuration ? element?.contractDuration : 'nil';
            }
          }
          if (paymentMethod) {
            let key = 'payment_method';
            item[key] = paymentMethod ? paymentMethod : '';
          }
          //home wireless price
          if (element.hasOwnProperty('displayName')) {
            if (element?.displayName == 'Home Wireless Premium' || element?.displayName == 'Home Wireless Advance') {
              item.price = element?.price?.rental;
              if (element?.addons != null && element?.addons.length > 0) {
                element?.addons.forEach((value, index) => {
                  const key = `router${index + 1}`;
                  item[key] = value.displayName
                });
              }
            }
          }
          //visitor line insurance
          if (element?.hasOwnProperty('displayName')) {
            if (element?.displayName?.toLowerCase()?.includes('visitor')) {
              if (element?.addons != null && element?.addons?.length > 0) {
                if (cart && cart?.totalPayNow) {
                  item.price = cart?.totalPayNow;
                }
                element?.addons?.forEach((value, index) => {
                  if (value?.parentDisplayName == 'Travel Insurance') {
                    const key = `insurance`;
                    item[key] = value?.displayName
                  }
                });
              }
            }
          }

          //smart pay configuration
          if (element?.paymentOptions?.id == '-1') {
            const key2 = 'payment_type';
            const key3 = 'smartpay';
            item[key2] = 'One time';
            item[key3] = 'No'
          }
          else if (element?.paymentOptions?.id != '-1') {
            const key2 = 'payment_tenure';
            const key3 = 'smartpay';
            if (element?.paymentOptions?.duration) {
              item[key2] = element?.paymentOptions?.duration + ' ' + 'Months' || '';
              item[key3] = 'Yes';
              const key4 = 'payment_type';
              item[key4] = 'smartpay';
              const key5 = 'smartpay_account';
              if (element?.newPostpaidPlan?.skuId) {
                item[key5] = 'Buy a new plan';
              }
              else if (element?.isExistingAccountNumber == true) {
                item[key5] = 'Link to existing plan';
              }
            }
          }
          let index = 0;
          if(extrasList && extrasList.length > 0){
            extras = extrasList.filter(x => x?.skuId == element?.skuId)[0]?.extras;
          }
          if (extras != null) {
            if (extras.length > 0) {
              extras.forEach(x => {
                index++;
                let key = "item_extras" + index;
                let value = x.label;

                item[key] = value;
              });
            } else {
              let key = 'item_extras1';
              let key2 = 'item_extras2'

              item[key] = 'nil';
              item[key2] = 'nil';
            }
          }
          else if (element?.dynamicAttributesExtendedEn != null) {
            element?.dynamicAttributesExtendedEn.forEach(x => {
              index++;
              let key = "item_extras" + index;
              let value = x?.label;

              item[key] = value;
            });
          }
          else {
            let key = 'item_extras1';
            let key2 = 'item_extras2'

            item[key] = 'nil';
            item[key2] = 'nil';
          }
          if(element?.commerceItemCategory && element?.commerceItemCategory == 'Postpaid_plan'){
            let key = 'deposit_payment';
            item[key] = this.getDepositPayment(cart);
            let key3 = 'postpaid_device';
            item[key3] = (element && element?.watchEid) ? "Apple Watch" : "Smartphone/Tablets";
          }
          if(element?.commerceItemCategory && element?.commerceItemCategory == 'Prepaid_plan'){
            let key4 = 'prepaid_device';
            item[key4] = (element && element?.watchEid) ? "Apple Watch" : "Smartphone/Tablets";
          }
          stitchings.forEach(stitch => {
            if (stitchFields && stitchFields[stitch]) {
              item[stitch] = stitchFields[stitch];
            }
          });
          cartItems.push(item);
        });
      }
      const login_type = this.UTS.getUserInfo()?.loginMethod === "1" ? "otp" : this.UTS.getUserInfo()?.loginMethod === "2"? "uae pass": "";

      let data = {
        event: event,
        section:section,
        info:info,
        user_login: this.isLoginUser() ? 'Logged In' : 'Guest',
        current_account_type: userAccountType || '', // Prepaid
        current_plan_name: planName || '', // dynamic value
        user_id: userInfo || '', // Capture user id . No PII data.
        language: (this.UTS.getLocaleLanguage() && this.UTS.getLocaleLanguage().toLowerCase() == 'en') ? 'en' : 'ar',
        device_type: this.UTS.getENV(),//App
        screen_name:screen,
        sub_section: sub_section,
        recharge_amount: rechargeAmount,
        user_type: this.isLoginUser() ? 'Loggedin' : 'Guest',
        login_type: login_type,
        ecommerce: {
          shipping_tier: 'Courier',
          items: cartItems
        }
      }
      this.pushDateOnGoogleAnalytics(data);
    } catch (e) {
      this.UTS.log(e);
    }
  }

  otpVerificationCheckout(event,info) {
    try {
      let userAccountInfo;
      let items=[];
      let cartItems = [];
      let userInfo ;
      let planName;
      let userAccountType;
      if (
        localStorage.getItem('userAccountInfo') != 'undefined' &&
        localStorage.getItem('userAccountInfo') != null
      ) {
          userAccountInfo = JSON.parse(localStorage.getItem('userAccountInfo'));
      }
      if (sessionStorage.getItem('planName')) {
        planName = sessionStorage.getItem('planName');
      }
      if(
        localStorage.getItem('userInfo') != 'undefined' &&
        localStorage.getItem('userInfo') != null
      ) {
        userInfo = JSON.parse(localStorage.getItem('userInfo'));
      }

      if (
        localStorage.getItem('CS') != 'undefined' &&
        localStorage.getItem('CS') != null
      ) {
        let cart = JSON.parse(localStorage.getItem('CS'));
        items=cart?.items;
      }
      if (localStorage.getItem('currentUserAccountType')) {
        userAccountType = localStorage.getItem('currentUserAccountType');
      }
      if (items != null && items.length > 0) {
        items.forEach((element) => {
          let item = {
            event: event,
            current_account_type: userAccountType ?? '', // Dynamic Value ex : Prepaid/postpaid
            current_plan_name: planName ?? '',// Dynamic Value.
            entry_point:  window?.location?.pathname  ?? '',//Capture the journey entry point as the section from where the user started the journey.
            section: this.getProductType(element )|| '', //dynamic name of the journey where the OTP screen comes
            sub_section: userAccountInfo
              ? SubSection.PRIMARY_ACCOUNT
              : SubSection.SECONDARY_ACCOUNT,// dynamic based on which account the user is currently logged in to.
            info: info,//dynamic capture how the otp was enetered.
            user_id: this.UTS.getUserId() ?? '',
            language: this.UTS.getLocaleLanguage(), // ar
            sku_id: element?.skuId,// Capture the SKU Id.
            device_type: this.UTS.getENV(),
            screen_name: ScreenName.OTPVERIFICATION,
            login_type:
              userInfo?.loginType == '1' ? LoginType.FULL : LoginType.INDIVIDUAL,
          };
          cartItems.push(item);
        });
      }
      let data = {
        event: event,
        ecommerce: {
          items: cartItems,
        },
      };
    this.pushDateOnGoogleAnalytics(data);
    } catch (e) {
      console.log(e);  }
  }
  getProductType(item: any) {
    let _type;
    if (item?.productType == 'MOBILE_CONTROLLINE') return (_type = 'control');
    else if (item?.commerceItemType == 'etsElifeSku') return (_type = 'elife');
    else if (item?.productType == 'MOBILE_POSTPAID') return (_type = 'postpaid');
    else if (item?.productType == 'MOBILE_PREPAID') return (_type = 'prepaid');
    else return (_type = 'device');
  }
  // ETWS-807 Tracking Plan Checkout Optimization start
  public checkoutOptimizationAddressContactInfo(event, section, sub_section, info, screen_name, items,stitchFields?,rechargeAmount?) {
    try {
      let userAccountType;
      let planName;

      if (sessionStorage.getItem('planName')) {
        planName = sessionStorage.getItem('planName');
      }
      if (localStorage.getItem('currentUserAccountType')) {
        userAccountType = localStorage.getItem('currentUserAccountType');
      }
      const userInfo = (this.UTS.getUserId()) ? this.UTS.getUserId() :  this.UTS.getUserInfo()?.userId;
      const login_type = this.UTS.getUserInfo()?.loginMethod === "1" ? "otp" : this.UTS.getUserInfo()?.loginMethod === "2"? "uae pass": "";
      const user_type = this.isLoginUser() ? 'Logged In' : 'Guest';
      const language = this.UTS.getLocaleLanguage() && this.UTS.getLocaleLanguage().toLowerCase() == 'ar' ? this.UTS.getLocaleLanguage() : 'en';
      const stitchings = ['utm_source', 'utm_campaign', 'utm_medium', 'entry_point'];
      const device_type = this.UTS.getENV(); //App
      let cartItems = [];

      if (items != null && items.length > 0) {
        items.forEach((element) => {
          let payload = {
            event: event || '',
            current_Account_type: userAccountType || '',
            current_plan_name: planName || '',
            entry_point: window.location.pathname || '',
            screen_name: screen_name || '',
            item_name: element?.displayName || '',
            item_brand: element?.brand ? element?.brand : "",
            item_category: this.getItemCatType(element) || '',
            user_type: user_type,
            login_type: login_type,
            section: section || '',
            info: info || '',
            user_id: userInfo || '', // No pii data
            language: language,
            sku_id: element?.skuId || '', // Capture the SKU Id
            device_type: device_type, //App
            sub_section: sub_section || '', //dynamic
            sim_type: element?.commerceItemSubType ? element?.commerceItemSubType : "",
            recharge_amount: rechargeAmount,
            prepaid_device: (element && element?.watchEid) ? "Apple Watch." : "Smartphone/Tablets",
          }
          stitchings.forEach(stitch => {
            if (stitchFields && stitchFields[stitch]) {
              payload[stitch] = stitchFields[stitch];
            }
          });
          cartItems.push(payload);
        });
        let data = {
          event: event,
          section:section,
          info:info,
          user_login: this.isLoginUser() ? 'Logged In' : 'Guest',
          current_account_type: userAccountType || '', // Prepaid
          current_plan_name: planName || '', // dynamic value
          user_id: userInfo || '', // Capture user id . No PII data.
          language: (this.UTS.getLocaleLanguage() && this.UTS.getLocaleLanguage().toLowerCase() == 'en') ? 'en' : 'ar',
          device_type: this.UTS.getENV(),//App
          screen_name:screen,
          ecommerce: {
            shipping_tier: 'Courier',
            items: cartItems
          }
        }
        this.pushDateOnGoogleAnalytics(data);
      }
    } catch (e) {
      console.log(e);
    }
  }
  getDepositPayment(cart) {
    let price = 0;
    if (cart && cart?.items && cart?.items.length > 0) {
      cart.items.forEach((item: any) => {
        let advancePayment = item?.itemPriceInfo?.advancePayment ? item?.itemPriceInfo?.advancePayment : item?.advancePayment;
        if (advancePayment) {
          let numAdvancePayment = Number(advancePayment); // Convert to number here
          if (numAdvancePayment == null || numAdvancePayment === undefined) {
            numAdvancePayment = 0; // Set to 0 if NaN or undefined
          }
          if (
            advancePayment &&
            advancePayment > 0
          ) {
            price += numAdvancePayment;
          }
        }

      });
    }
    return price;
  }
    // ETWS-807 Tracking Plan Checkout Optimization end
}
